// import TopUpList from './components/topUpList';
import { useSessionContext } from '@/contexts/session/context';
import MessageList from './components/messageList';
import styles from './index.module.scss';
import LockDesIcon from './components/messageList/images/lockDesc.svg?react';

const ChatSider = () => {
  const {
    session: { user },
  } = useSessionContext();

  if (!user) return null;

  return (
    <div className={styles.chatSider}>
      {/* <TopUpList></TopUpList> */}
      <MessageList user={user} />
      <div className={styles.chatDesc}>
        <LockDesIcon />
        <div>
          Your messages are <span>end-to-end encrypted</span>
        </div>
      </div>
    </div>
  );
};
export default ChatSider;
